export const journalCategoryTableColumns = [
  {
    field: "sessionNo",
    headerName: "Session",
    flex: 0.5,
    minWidth: 100,
    renderCell: (params) => (
      <span>Session {params.value}</span>
    ),
  },
  {
    field: "title",
    headerName: "Title",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "icon",
    headerName: "Icon",
    flex: 0.5,
    minWidth: 100,
    renderCell: (params) => (
      params.value ? (
        <img 
          src={params.value} 
          alt="Category Icon" 
          style={{ 
            width: "40px", 
            height: "40px", 
            objectFit: "contain",
            borderRadius: "4px"
          }} 
        />
      ) : (
        <span>No icon</span>
      )
    ),
  },
  {
    field: "questions",
    headerName: "Questions",
    flex: 0.5,
    minWidth: 100,
    renderCell: (params) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span>{params.row.questionCount || 0} questions</span>
        <button
          onClick={() => params.row.onView(params.row)}
          style={{
            padding: "4px 8px",
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "12px",
          }}
        >
          View
        </button>
      </div>
    ),
  },
  {
    field: "active",
    headerName: "Status",
    flex: 0.5,
    minWidth: 100,
    renderCell: (params) => (
      <span style={{ color: params.value ? "green" : "red" }}>
        {params.value ? "Active" : "Inactive"}
      </span>
    ),
  },
  {
    field: "actions",
    headerName: "Actions",
    flex: 1,
    minWidth: 200,
    renderCell: (params) => (
      <div style={{ display: "flex", gap: "8px" }}>
        <button
          onClick={() => params.row.onEdit(params.row)}
          style={{
            padding: "4px 8px",
            backgroundColor: "#ed6c02",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Edit
        </button>
        <button
          onClick={() => params.row.onDelete(params.row)}
          style={{
            padding: "4px 8px",
            backgroundColor: "#d32f2f",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Delete
        </button>
      </div>
    ),
  },
];

export const journalCategoryFormFields = [
  {
    name: "sessionNo",
    label: "Session Number",
    type: "option",
    required: true,
    options: [
      { value: 0, label: "Session 0" },
      { value: 1, label: "Session 1" },
      { value: 2, label: "Session 2" },
      { value: 3, label: "Session 3" },
      { value: 4, label: "Session 4" },
      { value: 5, label: "Session 5" },
      { value: 6, label: "Session 6" },
      { value: 7, label: "Session 7" },
      { value: 8, label: "Session 8" },
      { value: 9, label: "Session 9" },
      { value: 10, label: "Session 10" },
      { value: 11, label: "Session 11" },
      { value: 12, label: "Session 12" },
    ],
  },
  {
    name: "title",
    label: "Title",
    type: "text",
    required: true,
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    required: true,
  },
  {
    name: "icon",
    label: "Icon",
    type: "file",
    required: false,
    accept: "image/*",
  },
  {
    name: "order",
    label: "Order",
    type: "number",
    required: false,
    min: 0,
  },
]; 